import React from 'react';


const TermAndCondition = () => {
  return (
    <div className='m-16'>
      <h1 className='font-bold text-xl my-2'>Terms and Conditions</h1>
      <p className='text-gray-500'>
      Welcome to Akoi Foundation ("we," "our," or "us"). By accessing and using our website (akoifoundation.org), you agree to comply with the following terms and conditions.  
      </p>
      <h1 className='text-xl font-bold my-2'>Use of the Website</h1>
      <p className='text-gray-500'>
      The website provides information, services, and resources related to animal welfare, adoption, donations, and volunteering.  
      </p>
      <p className='text-gray-500'>
      You agree to use this website only for lawful purposes and in a manner that does not harm the reputation of our NGO or disrupt website operations.  
      </p>

      <h1 className='font-bold text-xl my-2'>Donations and Payments</h1>
      <p className='text-gray-500'>
      Donations made through our website are voluntary and non-refundable.  
      </p>
      <p className='text-gray-500'>
      We ensure transparency in fund usage, but donors do not have control over how funds are allocated. 
      </p>
      <p className='text-gray-500'>
      Payment details (such as credit card information) are processed securely by third-party payment providers. We do not store sensitive financial information.  
      </p>
      <p className='text-gray-500'>All donation will go to towards financing our shelter.</p>
      <h1 className='my-2 font-bold text-xl'>
      Animal Adoption & Volunteering
      </h1>
      <p className='text-gray-500'>
      Adoption applications are subject to verification and approval by our team.  
      </p>
      <p className='text-gray-500'>
      Volunteers must comply with our guidelines and safety measures when handling animals.  
      </p>
      <p className='text-gray-500'>
      We reserve the right to reject any adoption or volunteer application without explanation.  
      </p>
      <h4 className='text-xl font-bold my-2'>
      Intellectual Property
      </h4>
      <p className='text-gray-500'>
      All content on this website, including text, images, logos, and graphics, is owned by or licensed to akoi foundation. Unauthorized use is prohibited.  
      </p>
      <p className='text-gray-500'>
      You may share our content for educational and non-commercial purposes with proper attribution.  
      </p>
      <h1 className='font-bold text-xl'>
      Privacy Policy
      </h1>
      <p className='text-gray-500 '>
      We collect and store personal data in accordance with our Privacy Policy. 
      </p>
      <p className='text-gray-500'> 
      We do not sell or share personal information with third parties without consent.  
      </p>
      <h1 className='text-xl font-bold'>
      Third-Party Links
      </h1>
      <p className='text-gray-500'>
      Our website may contain links to third-party websites. We are not responsible for their content or privacy policies.  
      </p>
      <h1 className='text-xl font-bold'>
      Limitation of Liability
      </h1>
      <p className='text-gray-500'>
      We strive to provide accurate information but do not guarantee the completeness or correctness of content.  
      </p>
      <p className='text-gray-500'>
      We are not liable for any damages or losses arising from the use of our website. 
      </p>
      <h1 className='text-xl font-bold my-2'>Changes to Terms & Conditions</h1>
      <p className='text-gray-500'>
      We reserve the right to update these Terms and Conditions at any time. Changes will be effective upon posting.  
      </p>
      <h1 className='font-bold my-2'>Governing Law</h1>
      <p className='text-gray-500'>These Terms and Conditions are governed by the laws of India / Delhi. </p>
      <h1 className='text-xl font-bold my-2'>Contact Us</h1>
      <p className='text-gray-500'>For any questions or concerns, please contact us at:  
      </p>
      <p className='font-semibold'>Email :<a href="mailto:akoifoundation@gmail.com" className='text-gray-600'> akoifoundation@gmail.com</a></p>
      <p className='font-semibold'>Phone : <a href="tel:9354615602" className='text-gray-500'> 9354615602</a></p>
      <p className='font-semibold'>Address :<span className='text-gray-600'>14/19, Aya Nagar Jonapur Link Rd, New Delhi, Delhi 110047</span> </p>
    </div>
    
  );
};

export default TermAndCondition;
